<template>
    <div :id="'_id' + message.id" class="flex group w-fit min-w-80 lg:max-w-[40%] max-w-[60%] items-end">

        <div v-if="!selfMessage">
            <img :src="conversation?.profile" v-if="conversation?.profile" alt=""
                class="w-8 h-8 rounded-full dark:hidden" />
            <img src="@/assets/user5.svg" v-else alt="" class="w-8 h-8 rounded-full  dark:hidden" />

        </div>
        <div class="rounded-md flex-1"
            :class="selfMessage ? ' text-white text-justify w-full rounded-br-none bg-teal-900 p-2 mx-3  my-2' : 'bg-gray-200 my-2  ml-1 text-justify w-full rounded-bl-none p-2'">


            <div class="flex justify-between">
                <div class="flex items-center w-fit rounded-lg  mb-1 text-xs text-gray-500 ">
                    <i class=" fas fa-share mr-2   " v-if="message.isForwarded"></i>
                    <i v-if="message.isForwarded">Transféré</i>
                </div>
                <div class="text-end font-bold mb-1">
                    {{ message?.agent?.firstname ?? "" }}
                </div>
            </div>

            <div v-if="message.parent" @click="scrollToParentMessage"
                class=" w-full cursor-pointer hover:scale-95 bg-gray-900/20 border-l-4 border-l-gray-900/60  rounded-md  mb-2 flex ">

                <div class=" mx-2 line-clamp-3" >
                    <ReplyWidget :message="message.parent" />
                </div>

            </div>

            <div class="flex-1 flex items-center ">
                <div class="flex flex-1 items-center">
                    <div class="p-4 rounded bg-teal-900/60 ">
                        <i class="fas fa-user text-teal-900 "></i>
                    </div>
                    <div class="mx-1">
                        <b class="text-lg  mb-2">Contact</b>
                        <div class="text-xs line-clamp-1">V-card Whatsapp</div>
                    </div>
                </div>
                <div class="mx-2">
                    <i @click="donwloadVcard" class="fas fa-download p-2 cursor-pointer hover:scale-105 rounded-lg bg-gray-900/15"></i>
                </div>
            </div>
            
        </div>
        <div class="px-2 py-1 hover:scale-95 group-hover:bg-gray-200  cursor-pointer ml-3 group-hover:visible invisible rounded-full"
            :class="selfMessage ? 'order-first ' : ''" @click="setParentReply">
            <i class="fas fa-reply  text-xs"></i>
        </div>

    </div>



</template>
<script>
import { mapFields } from 'vuex-map-fields';
import ReplyWidget from './ReplyWidget.vue';

export default {
    name: "VCard",
    components:{
        ReplyWidget
    },
    props: {
        conversation: {
            type: Object,
            required: true
        },
        message: {
            type: Object,
            required: true
        },
        hour: {
            type: String,
            required: true
        },
        selfMessage: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    computed: {
        ...mapFields("messages/reply", {
            parentReply: "parentReply"
        })
    },
    methods: {
        setParentReply() {
            this.parentReply = this.message
        },
        scrollToParentMessage() {
            document.querySelector(`#_id${this.message?.parent_intern_id}`)?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
        },
        donwloadVcard() {
            window.open("data:text/x-vcard;urlencoded," + JSON.parse(this.message.content));
        }
    },
    mounted() {

    }
}
</script>